<template>
  <el-select v-model="nationvalue" filterable placeholder="请选择民族" class="add-nation-input" @change="nationChange" clearable>
    <el-option v-for="item in $store.state.nationList" :key="item.value" :label="item.info" :value="item.value"></el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      nationvalue: "",
      
    };
  },
  watch:{
    "nationvalue2": {
        handler(newVal, oldVal) {
          const list = this.$store.state.nationList;
          const item = list && list[newVal - 1];
          this.nationvalue = item ? item.info : "";
        },
        deep: true,
        immediate: true}
  },
  created() {
    if (this.nationV != undefined) {
      this.nationvalue = Number(this.nationV);
    }
    
  },
  props: ["nationV","nationvalue2"],
  methods: {
    nationChange() {
      this.$emit("nationvalue", this.nationvalue);
    },
  },
};
</script>
<style scoped>
.add-nation-input {
  width: 320px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/nationSelect.vue